<template>
<div class="create px-8 py-4">
    <div>
        <lCrumbs :breadcrumb="breadcrumbItems" />

        <div class="mb-8 text-xl text-black">Create Reward</div>
        <div class="mt-12">
            <div class="w-full">
                <div class="w-full">
                    <div class="md:mx-12">
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Reward Title:
                                </label>
                            </div>
                            <div class="w-full">
                                <linput :error="errors.title" :errorMessage="errors.title" placeholder="Reward Title" v-model="form.title" />
                            </div>
                        </div>
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Reward Description:
                                </label>
                            </div>
                            <div class="w-full">
                                <textarea placeholder="Description" v-model="form.description" cols="50" rows="3" class="w-full text-black text-xs rounded-md resize-none border focus:outline-none p-4"></textarea>
                                <span class="text-red-400" v-if="errors.description">{{
                    errors.description
                  }}</span>
                            </div>
                        </div>
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Select Reward Type:
                                </label>
                            </div>
                            <div class="w-full">
                                <lms-select @selected="fetchRewardType" v-model="form.reward_type" :items="items" />
                                <span class="text-red-400" v-if="errors.reward_type">{{
                    errors.reward_type
                  }}</span>
                            </div>
                        </div>
                        <div v-if="form.reward_type == 'point'" class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Select Leaderboard:
                                </label>
                            </div>
                            <div class="w-full">
                                <lms-select v-model="form.leaderboard_id" :items="lbods" />
                            </div>
                        </div>
                        <div v-if="form.reward_type == 'badge'" class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Select Badge:
                                </label>
                            </div>
                            <div class="w-full">
                                <lms-select v-model="form.badge_id" :items="badges" />
                                <span class="text-red-400" v-if="errors.badge_id">Select a Badge</span>
                            </div>
                        </div>
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Minimum Score:
                                </label>
                            </div>
                            <div class="w-full">
                                <linput :error="errors.min_score" :errorMessage="errors.min_score" placeholder="Minimum Score" v-model="form.min_score" />
                            </div>
                        </div>
                        <!--  -->
                        <div v-if="form.reward_type == 'point'" class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Reward Point:
                                </label>
                            </div>
                            <div class="w-full">
                                <linput :error="errors.reward_point" :errorMessage="errors.reward_point" placeholder="Reward Point" v-model="form.reward_point" />
                            </div>
                        </div>
                        <div class="item md:flex md:items-center w-full mb-12">
                            <div class="w-full md:w-1/4 mr-4">
                                <label class="text-black font-bold" for="">Select Gradable:
                                </label>
                            </div>
                            <div class="w-full">
                                <lms-select v-model="form.gradable_id" :items="gradables" type="gradable" />
                                <span class="text-red-400" v-if="errors.gradable_id">Select a gradeable</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full text-center">
                    <lms-button class="mb-12" @click="handleSubmit">Create </lms-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapGetters
} from "vuex";
import _get from "lodash.get";
import FormActions from "@/mixins/FormActions";
export default {
    mixins: [FormActions],
    data() {
        return {
            activeTab: 2,
            form: {},
            errors: {},
            badges: [],
            gradables: [],
            lbods: [],
            breadcrumbItems: [{
                    disabled: true,
                    to: "/tenant/rewards",
                    text: "All Rewards",
                },
                {
                    disabled: true,
                    to: "#",
                    text: "Create Reward",
                },
            ],
            items: [{
                    text: "Badge",
                    value: "badge",
                },
                {
                    text: "Point",
                    value: "point",
                },
            ],
        };
    },
    methods: {
        ...mapMutations(["updateLoader"]),
        ...mapActions([
            "tenantAllBadges",
            "tenantFetchLeaderboard",
            "tenantFetchAllGradable",
            "tenantCreateReward",
            "fetchTenantCourses"
        ]),
        async handleSubmit() {
            this.errors = [];
            this.updateLoader(true);
            let res = await this.tenantCreateReward(this.form);
            this.updateLoader(false);
            if (res.status == 201 || res.status == 200) {
                this.form = {};
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Reward created successfully",
                });

                this.$router.push({
                    name: "tenant-rewards-home",
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
        async fetchRewardType(e) {
            if (this.form.reward_type == "badge") {
                let res = await this.tenantAllBadges();

                res.data.data.badges.data.map((item) => {
                    this.badges.push({
                        text: item.title,
                        value: item.id,
                    });
                });
            } else if (this.form.reward_type == "point") {
                let res = await this.tenantFetchLeaderboard();
                res.data.data.leaderboards.data.map((item) => {
                    this.lbods.push({
                        text: item.title,
                        value: item.id,
                    });
                });
            }
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        steps: () => import("@/components/general/steps"),
        LmsSelect: () => import("@/components/forms/select"),
        LmsButton: () => import("@/components/general/button"),
        lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    },
    computed: {
        ...mapGetters(["getTenantCourses"])
    },
    async mounted() {
        this.updateLoader(true);
        await this.fetchTenantCourses();
        let res = await this.tenantFetchAllGradable();
        let data = [];
        res.data.data.gradables.map((item, index) => {
            let data = this.getTenantCourses.filter((course) => {
                return course.id === item.course_id && typeof course !== 'undefined';
            });
            this.gradables.push({
                text: item.title,
                value: item.id,
                course: data.length > 0 ? data[0].title : ''
            })
        });
        this.updateLoader(false);
    }
};
</script>
